import * as React from 'react';
import styled from 'styled-components';

interface IProps {
  selected: boolean;
  style?: React.CSSProperties;
  wrapperClass?: string;
  onSelect: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  disabled?: boolean;
  ariaLabel?: string;
  indeterminate?: boolean;
}

const SelectBox = (props: IProps): React.ReactElement => {
  return (
    <SelectBoxContainer style={props.style}>
      {props.label && <LabelContainer>{props.label}</LabelContainer>}
      <ControlContainer $disabled={props.disabled}>
        <SelectInput
          aria-label={props.ariaLabel || props.label || 'checkbox'}
          name={props.label}
          type='checkbox'
          checked={!!props.selected}
          onChange={props.onSelect}
          disabled={props.disabled}
        />
        {props.indeterminate ? <Indeterminate /> : props.selected ? <Selected /> : null}
      </ControlContainer>
    </SelectBoxContainer>
  );
};

export { SelectBox };
const LabelContainer = styled.div`
  margin-right: 5px;
`;

const SelectBoxContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ControlContainer = styled.div<{ $disabled?: boolean }>`
  width: 22px;
  height: 22px;
  color: var(--color-control-text);
  fill: rgba(255, 255, 255, 0.88);
  stroke: rgba(255, 255, 255, 0.88);
  transition: all 0.15s ease-in-out;
  background: var(--color-control-background);
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border: 1px solid var(--color-separator);
  opacity: ${(props): string => (props.$disabled ? '0.5' : '1')};
  cursor: ${(props): string => (props.$disabled ? 'not-allowed' : 'pointer')};
  &:hover {
    cursor: ${(props): string => (props.$disabled ? 'not-allowed' : 'pointer')};
  }
`;

const Selected = styled.div`
  height: 14px;
  width: 14px;
  background-color: var(--color-accent);
  border-radius: 3px;
`;

const Indeterminate = styled.div`
  height: 3px;
  width: 12px;
  background-color: var(--color-accent);
  border-radius: 2px;
`;

const SelectInput = styled.input`
  opacity: 0;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  width: 22px;
  height: 22px;
  margin: 0;
  z-index: 999;
  cursor: pointer;
  &:disabled {
    cursor: not-allowed;
  }
`;
